import request from '@/http/config/httpconfig';


// -----------------------------个人中心---------------------------
// 行业数据
export const GetNationalEconomyInfo = () => {
  return request({
      url: '/WebControl/GetNationalEconomyInfo',
      method: 'post'
  })
}

// 职称
export const GetTitleInfo = () => {
  return request({
      url: '/WebControl/GetTitleInfo',
      method: 'post'
  })
}

// 研究领域
export const GetResearchFieldInfo = () => {
  return request({
      url: '/WebControl/GetResearchFieldInfo',
      method: 'post'
  })
}

// 专业
export const GetMajorList = () => {
  return request({
      url: '/WebControl/GetMajorList',
      method: 'post'
  })
}

// 中途分类号
export const GetFenleiList = (data) => {
  return request({
      url: '/WebControl/GetFenleiList',
      method: 'post',
      params: data
  })
}
// 中小学学科分类
export const GetClassification = (data) => {
  return request({
      url: '/WebControl/GetClassification',
      method: 'post',
      data
  })
}
// 区域json
export const GetAreaInfo = (data) => {
  return request({
      url: '/WebControl/GetAreaInfo',
      method: 'post',
      data
  })
}

// ----------成果管理------------
// 添加
export const ManageAchievement = (data) => {
  return request({
      url: '/Achievement/ManageAchievement',
      method: 'post',
      data
  })
}
// 获取我的机构
export const GetMyOrgan = (params) => {
  return request({
      url: '/Achievement/GetMyOrgan',
      method: 'post',
      params
  })
}
// 成果列表
export const ShowMyAchievement = (data) => {
  return request({
      url: '/Achievement/ShowMyAchievement',
      method: 'post',
      data
  })
}
// 审核列表
export const MAchievement = (data) => {
  return request({
      url: '/Achievement/MAchievement',
      method: 'post',
      data
  })
}
// 审核信息列表
export const AchievementAuditList = (data) => {
  return request({
      url: '/Achievement/AchievementAuditList',
      method: 'post',
      params: data
  })
}
// 成果详细
export const GetAchievementModel = (data) => {
  return request({
      url: '/Achievement/GetAchievementModel',
      method: 'post',
      params: data
  })
}
// 视频添加修改
export const ManageVedioAchievement = (data) => {
  return request({
      url: '/Achievement/ManageVedioAchievement',
      method: 'post',
      data
  })
}
// 视频成果详细
export const GetVedioAchievementModel = (data) => {
  return request({
      url: '/Achievement/GetVedioAchievementModel',
      method: 'post',
      params: data
  })
}
// Api获取成果详细
export const DetailJson = (data) => {
  return request({
      url: '/Search/DetailJson',
      method: 'get',
      params: data
  })
}
// Api获取成果详细
export const GetArticleStatu = (data) => {
  return request({
      url: '/Achievement/GetArticleStatu',
      method: 'post',
      params: data
  })
}
// 提交成果api保存
export const EditAchievement = (data) => {
  return request({
      url: '/Achievement/EditAchievement',
      method: 'post',
      data
  })
}

export const EditMyAchievement = (data) => {
  return request({
      url: '/Achievement/EditMyAchievement',
      method: 'post',
      data
  })
}


// 成果解绑
export const RelieveAchievement = (data) => {
  return request({
      url: '/Achievement/RelieveAchievement',
      method: 'post',
      params: data
  })
}
// 认领操作
export const ClaimAchievement = (data) => {
  return request({
      url: '/Achievement/ClaimAchievement',
      method: 'post',
      params: data
  })
}
// 我的成果认领列表
export const ShowMyClaimList = (data) => {
  return request({
      url: '/Achievement/ShowMyClaimList',
      method: 'post',
      data
  })
}

// ----------基本信息------------

// 获取机构信息（机构）
export const GetSelfOrganInfo = (data) => {
  return request({
      url: '/OrganApplication/GetSelfOrganInfo',
      method: 'post',
      data
  })
}
// 分页获取教师信息（机构）
export const GetOrganSelfTeaListQueryPage = (data) => {
  return request({
      url: '/OrganApplication/GetOrganSelfTeaListQueryPage',
      method: 'post',
      data
  })
}

// 基本信息
export const GetUserInfo = (data) => {
  return request({
      url: '/UserInfo/GetUserInfo',
      method: 'post',
      data
  })
}
// 保存基本信息
export const BasicInfoEdit = (data) => {
  return request({
      url: '/UserInfo/BasicInfoEdit',
      method: 'post',
      data
  })
}
// 上传头像
export const PhotoPathEdit = (data) => {
  return request({
      url: '/UserInfo/PhotoPathEdit',
      method: 'post',
      params: data
  })
}
// 获取我的课程列表
//(PageIndex,PageSize,Type)
export const GetCourseListQueryPage = (data) => {
  return request({
      url: '/UserCenter/GetCourseListQueryPage',
      method: 'post',
      params: data
  })
}
// 获取我的收藏列表
//(PageIndex,PageSize,Type)
export const GetCollectListQueryPage = (data) => {
  return request({
      url: '/UserCenter/GetCollectListQueryPage',
      method: 'post',
      params: data
  })
}
// 获取我的关注列表
export const GetMyAttationListQueryPage = (data) => {
  return request({
      url: '/UserCenter/GetMyAttationListQueryPage',
      method: 'post',
      params: data
  })
}
// 获取我的粉丝列表
export const GetMyFansListQueryPage = (data) => {
  return request({
      url: '/UserCenter/GetMyFansListQueryPage',
      method: 'post',
      params: data
  })
}

// 获取我的下载记录
export const GetDownLoadRecordQueryPage = (data) => {
  return request({
      url: '/UserCenter/GetDownLoadRecordQueryPage',
      method: 'post',
      params: data
  })
}

// 获取我的文章浏览记录
export const GetArticleViewRecordQuery = (data) => {
  return request({
      url: '/UserCenter/GetArticleViewRecordQuery',
      method: 'post',
      params: data
  })
}

// 获取我的学者浏览记录
export const GetAuthorViewRecordQuery = (data) => {
  return request({
      url: '/UserCenter/GetAuthorViewRecordQuery',
      method: 'post',
      data
  })
}
//-----------------------------------教研活动-------------------
// 教研活动投稿报名列表
export const GetMyActiveSignUpQueryPage = (data) => {
  return request({
      url: '/TeachingActive/GetMyActiveSignUpQueryPage',
      method: 'post',
      data
  })
}

// 教研活动报名详情
export const GetMyActiveSignUpDetail = (data) => {
  return request({
      url: '/TeachingActive/GetMyActiveSignUpDetail',
      method: 'post',
      params: data
  })
}

// 报名投稿审核信息
export const TeachingActiveAuditList = (data) => {
  return request({
      url: '/TeachingActive/TeachingActiveAuditList',
      method: 'post',
      params: data
  })
}
// 报名投稿再次提交

export const SignUpReCommit = (data) => {
  return request({
      url: '/TeachingActive/SignUpReCommit',
      method: 'post',
      data
  })
}

// 选题分析
export const GetRedirectUrl = (data) => {
  return request({
      url: '/UserCenter/GetRedirectUrl',
      method: 'get',
      params: data
  })
}

// 投稿发表
export const ContributeUrl = (data) => {
  return request({
      url: '/OpreateLogin/ContributeUrl',
      method: 'post',
      data
  })
}

//我的卡券
export const GetMyCouponGroupListQueryPage = (data) => {
  return request({
    url: '/CardInfo/GetMyCouponGroupListQueryPage',
    method: 'post',
    data
  })
}

//激活卡券
export const AtctiveCard = (data) => {
  return request({
      url: '/CardInfo/AtctiveCard',
      method: 'post',
      params: data
  })
}

//发送用户注销验证码
export const SendDelPhoneCode = () => {
  return request({
      url: '/UserLoginReg/SendDelPhoneCode',
      method: 'post',
  })
}

//手机验证码用户注销
export const UserLogOffByPhone = (data) => {
  return request({
      url: '/UserLoginReg/UserLogOffByPhone',
      method: 'post',
      params: data
  })
}

/*----------------------新-我的卡券----------------------*/
//新-我的卡券
export const GetMyDiscountListQueryPage = (data) => {
    return request({
        url: '/MemberInfo/GetMyDiscountListQueryPage',
        method: 'post',
        data
    })
}

//会员表单提交
export const AddMemberForm = (data) => {
    return request({
        url: '/MemberInfo/AddMemberForm',
        method: 'post',
        data
    })
}

//会员表单编辑
export const UpdateMemberForm = (data) => {
    return request({
        url: '/MemberInfo/UpdateMemberForm',
        method: 'post',
        data
    })
}

//获取会员表单信息
export const GetMemberFormById = (data) => {
    return request({
        url: '/MemberInfo/GetMemberFormById',
        method: 'post',
        params: data
    })
}

/*----------------------会员列表----------------------*/
// 会员列表
export const GetMyMemberInfoListQueryPage = (data) => {
    return request({
        url: '/MemberInfo/GetMyMemberInfoListQueryPage',
        method: 'post',
        data
    })
}

// 线下表单提交列表
export const GetMyMemberFormListQueryPageBy = (data) => {
    return request({
        url: '/MemberInfo/GetMyMemberFormListQueryPageBy',
        method: 'post',
        data
    })
}

// 订单列表
export const GetMyOrderRecordListQueryPage = (data) => {
    return request({
        url: '/MemberInfo/GetMyOrderRecordListQueryPage',
        method: 'post',
        data
    })
}
